import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogModule, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { ClampJoint, CustomValidators } from 'cloud-shared-lib';

@Component({
  templateUrl: 'countertop-connector-dialog.component.html',
  standalone: true,
  imports: [
    MatIconModule,
    MatLegacyDialogModule,
    MatLegacyButtonModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class CountertopConnectorDialogComponent {
  count = new FormControl(this.connector.count, [
    Validators.required,
    Validators.max(Math.floor((this.connector.workJointLength - this.connector.edgeOffset * 2) / this.connector.d)),
    Validators.min(2),
    CustomValidators.digits,
  ]);

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) private connector: ClampJoint,
    public dialogRef: MatLegacyDialogRef<CountertopConnectorDialogComponent>
  ) {}

  saveAndClose(): void {
    this.connector.interval = (this.connector.workJointLength - this.connector.edgeOffset * 2) / (this.count.value - 1);
    this.connector.count = this.count.value;

    this.dialogRef.close(this.connector);
  }
}
